import { FC } from "react";
import { Supplier } from "../../../../types/slices/supplierType";
import { Button, Divider, Drawer, FormLabel, Grid, IconButton, TextField, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CustomTable from "../../../../components/common/CustomTable/CustomTable";
import './../../../../assets/styles/facturacionv3-app.css';

interface Props {
    open: boolean
    onClose: () => void
    customer: Supplier
}

interface onList {
    page?: number
    perPage?: number
    idsupplier?: number
    search?: string
}

const columns = [
    { type: 'text', field: 'folio', label: 'Folio', align: 'center' },
    { type: 'text', field: 'total', label: 'Monto', align: 'center' },
    { type: 'detail', field: 'detail', label: 'Detalle', align: 'center' },
]

const rows = [
    { folio: '001', total: "1000", type: 'Transferencia', align: 'center' },
    { folio: '002', total: "1000", type: 'Efectivo', align: 'center' },
    { folio: '003', total: "1000", type: 'Tarjeta de crédito', align: 'center' },
    { folio: '004', total: "1000", type: 'Depósito', align: 'center' },
    { folio: '005', total: "1000", type: 'Cheque', align: 'center' }
]

export const PayDrawer: FC<Props> = (props) => {
    const { open, onClose, customer } = props

    const onSearch = () => { }
    const onDetails = () => { }

    return (
        <Drawer
            open={open}
            onClose={onClose}
            anchor="right"
        >
            <Grid container sx={{ width: 800, padding: 2 }} spacing={2}>
                <IconButton
                    onClick={onClose}
                    sx={{
                        position: "absolute",
                        top: 8,
                        right: 8
                    }}
                >
                    <CloseIcon />
                </IconButton>

                <Grid item xs={12}>
                    <Typography variant="h6">
                        Abonar
                    </Typography>
                </Grid>
                <Grid item xs={12} mb={1}>
                    <Divider />
                </Grid>
                <Grid item container sx={{ alignItems: 'center', display: 'flex', justifyContent: 'center', flexWrap: 'wrap', marginBottom: '10px' }}>
                    <Typography variant='h6' component='h1' gutterBottom sx={{ mt: 1, ml: 1 }} className='title-main'>
                        {(customer.name_rz).toUpperCase()}
                    </Typography>
                </Grid>

                <Grid item xs={6}>
                    <TextField
                        id="phone"
                        type="text"
                        name="phone"
                        size="small"
                        label="Buscar"
                    />
                </Grid>
                <Grid container item xs={6} alignItems="center" spacing={2}>
                    <Grid item>
                        <TextField
                            id="phone"
                            type="text"
                            name="phone"
                            size="small"
                            label="Monto a abonar"
                        />
                    </Grid>
                    <Grid item>
                        <Button
                            onClick={() => null}
                            className="btn-table"
                            style={{ textTransform: 'none' }}
                            size="small"
                        >
                            Abonar
                        </Button>
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <CustomTable
                        columns={columns}
                        rows={rows || []}
                        onRowClick={() => { }}
                        hasOptions
                        onDetails={onDetails}
                        dense
                        withoutTitle
                    />
                </Grid>
            </Grid>
        </Drawer>
    )
}